import React from 'react';
import { intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SPECIAL_REQUEST, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemSpecialRequestsMaybe = props => {
  const { lineItems, specialRequests, intl } = props;
  if (!specialRequests?.length) return null;

  const specialRequestsLineItems = lineItems.filter(
    item => item.code.startsWith(LINE_ITEM_SPECIAL_REQUEST) && !item.reversal
  );

  if (!specialRequestsLineItems?.length) return null;

  return (
    <>
      <hr className={css.totalDivider} />
      {specialRequestsLineItems.map(lineItem => {
        const splitLineItemCode = lineItem.code.split('-');

        const specialRequestIdFromLineItem = splitLineItemCode[splitLineItemCode.length - 1];

        const specialRequest = specialRequests.find(a => a.id === specialRequestIdFromLineItem);

        return (
          <div>
            <div key={lineItem.code} className={css.lineItem}>
              <span className={css.itemLabel}>
                <span>{specialRequest?.name}</span>{' '}
              </span>

              <span className={css.itemValue}>{formatMoney(intl, lineItem.lineTotal)}</span>
            </div>
            {specialRequest?.description && (
              <div className={css.description} id="EditDetailsForm.numOfBandMembers">
                {specialRequest.description}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

LineItemSpecialRequestsMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemSpecialRequestsMaybe;
